import { Injectable } from '@angular/core';
import { TaxAuthorityPayload, TaxRateAreaPayload, PanelProjectionsPayload } from './tax.rate.model';
import { BaseRepository } from '../Common/Data/base.repository';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom, Observable } from 'rxjs';

@Injectable(
    { providedIn: 'root' }
)
export class TaxRateService extends BaseRepository {

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    getTaxRateArea(taxRateAreaId: number): Promise<TaxRateAreaPayload> {
        return lastValueFrom(this.httpGet(`/api/TaxRateArea/Panel/${taxRateAreaId}`));
    }

    updateTaxRateArea(taxRateAreaPayload: TaxRateAreaPayload): Promise<TaxRateAreaPayload> {
        return lastValueFrom(this.httpPut('/api/TaxRateArea/Panel/', taxRateAreaPayload));
    }

    createTaxRateArea(taxRateArea: TaxRateAreaPayload): Promise<TaxRateAreaPayload> {
        return lastValueFrom(this.httpPost('/api/TaxRateArea/Panel/', taxRateArea));
    }

    deleteTaxRateArea(taxRateAreaId: number): Promise<number> {
        return lastValueFrom(this.httpDelete(`/api/TaxRateArea/Panel/${taxRateAreaId}`));
    }

    getTaxAuthority(taxAuthorityId: number): Promise<TaxAuthorityPayload> {
        return lastValueFrom(this.httpGet(`/api/TaxAuthority/${taxAuthorityId}`));
    }

    updateTaxAuthority(taxAuthorityPayload: TaxAuthorityPayload): Promise<TaxAuthorityPayload> {
        return lastValueFrom(this.httpPut('/api/TaxAuthority/', taxAuthorityPayload));
    }

    createTaxAuthority(TaxAuthority: TaxAuthorityPayload): Promise<TaxAuthorityPayload> {
        return lastValueFrom(this.httpPost('/api/TaxAuthority/', TaxAuthority));
    }

    deleteTaxAuthority(taxAuthorityId: number, force: boolean): Observable<number> {
        return this.httpDelete(`/api/TaxAuthority/${taxAuthorityId}?force=${force}`);
    }

    getPanelProjections(panelProjectionsPayload: PanelProjectionsPayload): Promise<PanelProjectionsPayload> {
        return lastValueFrom(this.httpPost('/api/TaxRateArea/PanelProjections', panelProjectionsPayload));
    }

    cloneTaxRateArea(taxRateAreaId: number): Promise<TaxRateAreaPayload> {
        return lastValueFrom(this.httpPost(`/api/TaxRateArea/Duplicate/${taxRateAreaId}`, null));
    }
}
